import ConfigProvider from './ConfigProvider';

export { ConfigProvider };
export type { ConfigProviderProps } from './type';
export { PortalRef } from './ConfigProvider';
